export const portalTicketDetailTranslations = {
  "de": {
    "opened_by": "Eröffnet von",
    "affected_person": "Betroffene Person",
    "on_behalf": "Für jemand anderen gemeldet",
    "not_recorded": "Nicht hinterlegt",
    "category_pending": "Wird vom Support zugeordnet",
    "request_form": "Service-Anfrage",
    "channel": "Eingangskanal",
    "timeline": "Zeitlicher Verlauf",
    "first_response": "Erste Supportantwort",
    "response_pending": "Noch keine Antwort",
    "recorded_work": "Erfasster Aufwand",
    "service_targets": "Servicefristen",
    "response_target": "Reaktion bis",
    "resolution_target": "Lösung bis",
    "no_service_targets": "Für dieses Ticket sind keine Servicefristen hinterlegt.",
    "close_ticket": "Ticket schließen",
    "latest_message": "Letzte Nachricht zum Ticket",
    "read_message": "Meldung lesen",
    "conversation_empty": "Sobald der Support antwortet, erscheint die Nachricht hier.",
    "ticket_information": "Ticketinformationen",
    "file_integrity": "Dateiintegrität (SHA-256)",
    "conversation": "Konversation",
    "conversation_hint": "Nachrichten zwischen Ihnen und dem Supportteam.",
    "current_status": "Aktueller Stand",
    "next_step": "Nächster Schritt",
    "action_required": "Ihre Antwort wird benötigt",
    "reply_now": "Jetzt antworten",
    "go_conversation": "Zur Konversation",
    "queue": "Der Support übernimmt Ihr Ticket",
    "queue_hint": "Ihr Anliegen ist eingegangen. Aktuell müssen Sie nichts weiter tun.",
    "working": "Der Support bearbeitet Ihr Ticket",
    "working_hint": "Aktuell ist keine Antwort von Ihnen erforderlich. Neue Nachrichten finden Sie in der Konversation.",
    "waiting": "Der Support wartet auf den nächsten Bearbeitungsschritt",
    "complete": "Der Vorgang ist abgeschlossen",
    "complete_hint": "Falls das Anliegen weiter besteht, können Sie das Ticket wieder öffnen.",
    "external": "Bearbeitung bei {{name}}",
    "handoff_failed": "Der Support prüft die Übergabe",
    "initial_message": "Ursprüngliche Meldung",
    "earlier_messages": "Frühere Nachrichten",
    "attachments_hint": "Vorschau erst über das Augen-Symbol öffnen.",
    "all_files": "Alle Dateien anzeigen",
    "fewer_files": "Weniger Dateien anzeigen",
    "preview_file": "Vorschau öffnen: {{name}}",
    "download_file": "Datei herunterladen: {{name}}"
  },
  "en": {
    "opened_by": "Opened by",
    "affected_person": "Affected person",
    "on_behalf": "Reported for someone else",
    "not_recorded": "Not recorded",
    "category_pending": "Support will assign a category",
    "request_form": "Service request",
    "channel": "Received via",
    "timeline": "Timeline",
    "first_response": "First support reply",
    "response_pending": "No reply yet",
    "recorded_work": "Recorded effort",
    "service_targets": "Service targets",
    "response_target": "Response due",
    "resolution_target": "Resolution due",
    "no_service_targets": "No service deadlines are recorded for this ticket.",
    "close_ticket": "Close ticket",
    "latest_message": "Latest message about this ticket",
    "read_message": "Read message",
    "conversation_empty": "The support team’s reply will appear here.",
    "ticket_information": "Ticket information",
    "file_integrity": "File integrity (SHA-256)",
    "conversation": "Conversation",
    "conversation_hint": "Messages between you and the support team.",
    "current_status": "Current status",
    "next_step": "Next step",
    "action_required": "Your reply is needed",
    "reply_now": "Reply now",
    "go_conversation": "Go to conversation",
    "queue": "Support will pick up your ticket",
    "queue_hint": "We have received your request. You do not need to do anything else right now.",
    "working": "Support is working on your ticket",
    "working_hint": "No reply is needed from you right now. New messages appear in the conversation.",
    "waiting": "Support is waiting for the next processing step",
    "complete": "This ticket is complete",
    "complete_hint": "You can reopen the ticket if the issue persists.",
    "external": "Being handled by {{name}}",
    "handoff_failed": "Support is checking the handover",
    "initial_message": "Original message",
    "earlier_messages": "Earlier messages",
    "attachments_hint": "Use the eye icon to open a preview.",
    "all_files": "Show all files",
    "fewer_files": "Show fewer files",
    "preview_file": "Open preview: {{name}}",
    "download_file": "Download file: {{name}}"
  },
  "fr": {
    "opened_by": "Ouvert par",
    "affected_person": "Personne concernée",
    "on_behalf": "Signalé pour une autre personne",
    "not_recorded": "Non renseigné",
    "category_pending": "Le support attribuera une catégorie",
    "request_form": "Demande de service",
    "channel": "Canal de réception",
    "timeline": "Chronologie",
    "first_response": "Première réponse du support",
    "response_pending": "Pas encore de réponse",
    "recorded_work": "Temps enregistré",
    "service_targets": "Délais de service",
    "response_target": "Réponse avant",
    "resolution_target": "Résolution avant",
    "no_service_targets": "Aucun délai de service enregistré pour ce ticket.",
    "close_ticket": "Fermer le ticket",
    "latest_message": "Dernier message concernant le ticket",
    "read_message": "Lire le message",
    "conversation_empty": "La réponse du support apparaîtra ici.",
    "ticket_information": "Informations du ticket",
    "file_integrity": "Intégrité des fichiers (SHA-256)",
    "conversation": "Conversation",
    "conversation_hint": "Messages entre vous et l’équipe de support.",
    "current_status": "État actuel",
    "next_step": "Prochaine étape",
    "action_required": "Votre réponse est attendue",
    "reply_now": "Répondre maintenant",
    "go_conversation": "Voir la conversation",
    "queue": "Le support va prendre en charge votre ticket",
    "queue_hint": "Votre demande a été reçue. Aucune action supplémentaire n’est nécessaire pour le moment.",
    "working": "Le support traite votre ticket",
    "working_hint": "Aucune réponse n’est attendue pour le moment. Les nouveaux messages apparaissent dans la conversation.",
    "waiting": "Le support attend la prochaine étape de traitement",
    "complete": "Ce ticket est terminé",
    "complete_hint": "Vous pouvez rouvrir le ticket si le problème persiste.",
    "external": "Traitement par {{name}}",
    "handoff_failed": "Le support vérifie le transfert",
    "initial_message": "Message initial",
    "earlier_messages": "Messages précédents",
    "attachments_hint": "Ouvrez l’aperçu avec l’icône en forme d’œil.",
    "all_files": "Afficher tous les fichiers",
    "fewer_files": "Afficher moins de fichiers",
    "preview_file": "Ouvrir l’aperçu : {{name}}",
    "download_file": "Télécharger le fichier : {{name}}"
  },
  "es": {
    "opened_by": "Abierto por",
    "affected_person": "Persona afectada",
    "on_behalf": "Comunicado para otra persona",
    "not_recorded": "Sin registrar",
    "category_pending": "Soporte asignará una categoría",
    "request_form": "Solicitud de servicio",
    "channel": "Canal de entrada",
    "timeline": "Cronología",
    "first_response": "Primera respuesta de soporte",
    "response_pending": "Sin respuesta todavía",
    "recorded_work": "Tiempo registrado",
    "service_targets": "Plazos de servicio",
    "response_target": "Respuesta antes de",
    "resolution_target": "Resolución antes de",
    "no_service_targets": "No hay plazos de servicio registrados para este ticket.",
    "close_ticket": "Cerrar ticket",
    "latest_message": "Último mensaje sobre el ticket",
    "read_message": "Leer mensaje",
    "conversation_empty": "La respuesta del soporte aparecerá aquí.",
    "ticket_information": "Información del ticket",
    "file_integrity": "Integridad de archivos (SHA-256)",
    "conversation": "Conversación",
    "conversation_hint": "Mensajes entre usted y el equipo de soporte.",
    "current_status": "Estado actual",
    "next_step": "Siguiente paso",
    "action_required": "Se necesita su respuesta",
    "reply_now": "Responder ahora",
    "go_conversation": "Ver conversación",
    "queue": "El soporte se hará cargo de su ticket",
    "queue_hint": "Hemos recibido su solicitud. No necesita hacer nada más por ahora.",
    "working": "El soporte está trabajando en su ticket",
    "working_hint": "No se necesita su respuesta por ahora. Los nuevos mensajes aparecen en la conversación.",
    "waiting": "El soporte espera el siguiente paso de gestión",
    "complete": "Este ticket está finalizado",
    "complete_hint": "Puede reabrir el ticket si el problema persiste.",
    "external": "En gestión por {{name}}",
    "handoff_failed": "El soporte está comprobando la transferencia",
    "initial_message": "Mensaje original",
    "earlier_messages": "Mensajes anteriores",
    "attachments_hint": "Abra la vista previa con el icono del ojo.",
    "all_files": "Mostrar todos los archivos",
    "fewer_files": "Mostrar menos archivos",
    "preview_file": "Abrir vista previa: {{name}}",
    "download_file": "Descargar archivo: {{name}}"
  },
  "ru": {
    "opened_by": "Создано",
    "affected_person": "Затронутый сотрудник",
    "on_behalf": "Заявка для другого сотрудника",
    "not_recorded": "Не указано",
    "category_pending": "Поддержка назначит категорию",
    "request_form": "Запрос услуги",
    "channel": "Канал обращения",
    "timeline": "Хронология",
    "first_response": "Первый ответ поддержки",
    "response_pending": "Ответа пока нет",
    "recorded_work": "Учтённое время",
    "service_targets": "Сроки обслуживания",
    "response_target": "Ответ до",
    "resolution_target": "Решение до",
    "no_service_targets": "Для этой заявки сроки обслуживания не указаны.",
    "close_ticket": "Закрыть заявку",
    "latest_message": "Последнее сообщение по заявке",
    "read_message": "Прочитать обращение",
    "conversation_empty": "Ответ службы поддержки появится здесь.",
    "ticket_information": "Информация о заявке",
    "file_integrity": "Целостность файлов (SHA-256)",
    "conversation": "Переписка",
    "conversation_hint": "Сообщения между вами и службой поддержки.",
    "current_status": "Текущее состояние",
    "next_step": "Следующий шаг",
    "action_required": "Ожидается ваш ответ",
    "reply_now": "Ответить сейчас",
    "go_conversation": "Перейти к переписке",
    "queue": "Поддержка примет вашу заявку",
    "queue_hint": "Ваше обращение получено. Пока дополнительных действий не требуется.",
    "working": "Поддержка работает над вашей заявкой",
    "working_hint": "Ваш ответ пока не требуется. Новые сообщения появятся в переписке.",
    "waiting": "Поддержка ожидает следующего этапа обработки",
    "complete": "Заявка завершена",
    "complete_hint": "Если проблема сохраняется, заявку можно открыть снова.",
    "external": "Обрабатывает {{name}}",
    "handoff_failed": "Поддержка проверяет передачу",
    "initial_message": "Исходное сообщение",
    "earlier_messages": "Предыдущие сообщения",
    "attachments_hint": "Откройте предпросмотр с помощью значка глаза.",
    "all_files": "Показать все файлы",
    "fewer_files": "Показать меньше файлов",
    "preview_file": "Открыть предпросмотр: {{name}}",
    "download_file": "Скачать файл: {{name}}"
  },
  "pt": {
    "opened_by": "Aberto por",
    "affected_person": "Pessoa afetada",
    "on_behalf": "Comunicado para outra pessoa",
    "not_recorded": "Não registado",
    "category_pending": "O suporte atribuirá uma categoria",
    "request_form": "Pedido de serviço",
    "channel": "Canal de entrada",
    "timeline": "Cronologia",
    "first_response": "Primeira resposta do suporte",
    "response_pending": "Ainda sem resposta",
    "recorded_work": "Tempo registado",
    "service_targets": "Prazos de serviço",
    "response_target": "Resposta até",
    "resolution_target": "Resolução até",
    "no_service_targets": "Não há prazos de serviço registados para este pedido.",
    "close_ticket": "Fechar pedido",
    "latest_message": "Última mensagem sobre o pedido",
    "read_message": "Ler mensagem",
    "conversation_empty": "A resposta do suporte aparecerá aqui.",
    "ticket_information": "Informações do pedido",
    "file_integrity": "Integridade dos ficheiros (SHA-256)",
    "conversation": "Conversa",
    "conversation_hint": "Mensagens entre si e a equipa de suporte.",
    "current_status": "Estado atual",
    "next_step": "Próximo passo",
    "action_required": "A sua resposta é necessária",
    "reply_now": "Responder agora",
    "go_conversation": "Ver conversa",
    "queue": "O suporte vai assumir o seu pedido",
    "queue_hint": "Recebemos o seu pedido. Não precisa de fazer mais nada neste momento.",
    "working": "O suporte está a tratar do seu pedido",
    "working_hint": "Não é necessária uma resposta neste momento. As novas mensagens aparecem na conversa.",
    "waiting": "O suporte aguarda o próximo passo de tratamento",
    "complete": "Este pedido está concluído",
    "complete_hint": "Pode reabrir o pedido se o problema persistir.",
    "external": "Em tratamento por {{name}}",
    "handoff_failed": "O suporte está a verificar a transferência",
    "initial_message": "Mensagem original",
    "earlier_messages": "Mensagens anteriores",
    "attachments_hint": "Abra a pré-visualização com o ícone do olho.",
    "all_files": "Mostrar todos os ficheiros",
    "fewer_files": "Mostrar menos ficheiros",
    "preview_file": "Abrir pré-visualização: {{name}}",
    "download_file": "Descarregar ficheiro: {{name}}"
  },
  "pl": {
    "opened_by": "Utworzone przez",
    "affected_person": "Osoba, której dotyczy",
    "on_behalf": "Zgłoszone dla innej osoby",
    "not_recorded": "Nie zapisano",
    "category_pending": "Wsparcie przypisze kategorię",
    "request_form": "Wniosek o usługę",
    "channel": "Kanał zgłoszenia",
    "timeline": "Historia czasu",
    "first_response": "Pierwsza odpowiedź wsparcia",
    "response_pending": "Jeszcze brak odpowiedzi",
    "recorded_work": "Zarejestrowany czas",
    "service_targets": "Terminy obsługi",
    "response_target": "Odpowiedź do",
    "resolution_target": "Rozwiązanie do",
    "no_service_targets": "Dla tego zgłoszenia nie zapisano terminów obsługi.",
    "close_ticket": "Zamknij zgłoszenie",
    "latest_message": "Ostatnia wiadomość dotycząca zgłoszenia",
    "read_message": "Przeczytaj zgłoszenie",
    "conversation_empty": "Odpowiedź wsparcia pojawi się tutaj.",
    "ticket_information": "Informacje o zgłoszeniu",
    "file_integrity": "Integralność plików (SHA-256)",
    "conversation": "Rozmowa",
    "conversation_hint": "Wiadomości między Tobą a zespołem wsparcia.",
    "current_status": "Aktualny stan",
    "next_step": "Następny krok",
    "action_required": "Potrzebna jest Twoja odpowiedź",
    "reply_now": "Odpowiedz teraz",
    "go_conversation": "Przejdź do rozmowy",
    "queue": "Wsparcie zajmie się Twoim zgłoszeniem",
    "queue_hint": "Otrzymaliśmy Twoje zgłoszenie. Na razie nie musisz nic więcej robić.",
    "working": "Wsparcie pracuje nad Twoim zgłoszeniem",
    "working_hint": "Na razie nie jest potrzebna Twoja odpowiedź. Nowe wiadomości pojawią się w rozmowie.",
    "waiting": "Wsparcie czeka na kolejny etap obsługi",
    "complete": "Zgłoszenie jest zakończone",
    "complete_hint": "Jeśli problem nadal występuje, możesz ponownie otworzyć zgłoszenie.",
    "external": "Obsługuje {{name}}",
    "handoff_failed": "Wsparcie sprawdza przekazanie",
    "initial_message": "Pierwotna wiadomość",
    "earlier_messages": "Wcześniejsze wiadomości",
    "attachments_hint": "Otwórz podgląd ikoną oka.",
    "all_files": "Pokaż wszystkie pliki",
    "fewer_files": "Pokaż mniej plików",
    "preview_file": "Otwórz podgląd: {{name}}",
    "download_file": "Pobierz plik: {{name}}"
  },
  "nl": {
    "opened_by": "Geopend door",
    "affected_person": "Betrokken persoon",
    "on_behalf": "Gemeld voor iemand anders",
    "not_recorded": "Niet vastgelegd",
    "category_pending": "Support wijst een categorie toe",
    "request_form": "Serviceaanvraag",
    "channel": "Ontvangen via",
    "timeline": "Tijdlijn",
    "first_response": "Eerste antwoord van support",
    "response_pending": "Nog geen antwoord",
    "recorded_work": "Geregistreerde tijd",
    "service_targets": "Servicetermijnen",
    "response_target": "Reactie uiterlijk",
    "resolution_target": "Oplossing uiterlijk",
    "no_service_targets": "Voor dit ticket zijn geen servicetermijnen vastgelegd.",
    "close_ticket": "Ticket sluiten",
    "latest_message": "Laatste bericht over dit ticket",
    "read_message": "Melding lezen",
    "conversation_empty": "Het antwoord van support verschijnt hier.",
    "ticket_information": "Ticketinformatie",
    "file_integrity": "Bestandsintegriteit (SHA-256)",
    "conversation": "Gesprek",
    "conversation_hint": "Berichten tussen u en het supportteam.",
    "current_status": "Huidige status",
    "next_step": "Volgende stap",
    "action_required": "Uw antwoord is nodig",
    "reply_now": "Nu antwoorden",
    "go_conversation": "Naar het gesprek",
    "queue": "Support neemt uw ticket in behandeling",
    "queue_hint": "Uw aanvraag is ontvangen. U hoeft nu verder niets te doen.",
    "working": "Support werkt aan uw ticket",
    "working_hint": "Uw antwoord is nu niet nodig. Nieuwe berichten verschijnen in het gesprek.",
    "waiting": "Support wacht op de volgende behandelingsstap",
    "complete": "Dit ticket is afgerond",
    "complete_hint": "U kunt het ticket heropenen als het probleem blijft bestaan.",
    "external": "In behandeling bij {{name}}",
    "handoff_failed": "Support controleert de overdracht",
    "initial_message": "Oorspronkelijk bericht",
    "earlier_messages": "Eerdere berichten",
    "attachments_hint": "Open het voorbeeld met het oogpictogram.",
    "all_files": "Alle bestanden tonen",
    "fewer_files": "Minder bestanden tonen",
    "preview_file": "Voorbeeld openen: {{name}}",
    "download_file": "Bestand downloaden: {{name}}"
  },
  "be": {
    "opened_by": "Geopend door",
    "affected_person": "Betrokken persoon",
    "on_behalf": "Gemeld voor iemand anders",
    "not_recorded": "Niet vastgelegd",
    "category_pending": "Support wijst een categorie toe",
    "request_form": "Serviceaanvraag",
    "channel": "Ontvangen via",
    "timeline": "Tijdlijn",
    "first_response": "Eerste antwoord van support",
    "response_pending": "Nog geen antwoord",
    "recorded_work": "Geregistreerde tijd",
    "service_targets": "Servicetermijnen",
    "response_target": "Reactie uiterlijk",
    "resolution_target": "Oplossing uiterlijk",
    "no_service_targets": "Voor dit ticket zijn geen servicetermijnen vastgelegd.",
    "close_ticket": "Ticket sluiten",
    "latest_message": "Laatste bericht over dit ticket",
    "read_message": "Melding lezen",
    "conversation_empty": "Het antwoord van support verschijnt hier.",
    "ticket_information": "Ticketinformatie",
    "file_integrity": "Bestandsintegriteit (SHA-256)",
    "conversation": "Gesprek",
    "conversation_hint": "Berichten tussen u en het supportteam.",
    "current_status": "Huidige status",
    "next_step": "Volgende stap",
    "action_required": "Uw antwoord is nodig",
    "reply_now": "Nu antwoorden",
    "go_conversation": "Naar het gesprek",
    "queue": "Support neemt uw ticket in behandeling",
    "queue_hint": "Uw aanvraag is ontvangen. U hoeft nu verder niets te doen.",
    "working": "Support werkt aan uw ticket",
    "working_hint": "Uw antwoord is nu niet nodig. Nieuwe berichten verschijnen in het gesprek.",
    "waiting": "Support wacht op de volgende behandelingsstap",
    "complete": "Dit ticket is afgerond",
    "complete_hint": "U kunt het ticket heropenen als het probleem blijft bestaan.",
    "external": "In behandeling bij {{name}}",
    "handoff_failed": "Support controleert de overdracht",
    "initial_message": "Oorspronkelijk bericht",
    "earlier_messages": "Eerdere berichten",
    "attachments_hint": "Open het voorbeeld met het oogpictogram.",
    "all_files": "Alle bestanden tonen",
    "fewer_files": "Minder bestanden tonen",
    "preview_file": "Voorbeeld openen: {{name}}",
    "download_file": "Bestand downloaden: {{name}}"
  }
};
